var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "image-bot-response-container" }, [
    _c("div", { staticClass: "mode-selector" }, [
      _c(
        "div",
        { staticClass: "mode-switch-container" },
        [
          _c(
            "span",
            {
              staticClass: "mode-label",
              class: { active: _vm.currentMode === "static" },
              on: {
                click: function ($event) {
                  return _vm.setMode("static")
                },
              },
            },
            [
              _c("span", { staticClass: "material-icons" }, [
                _vm._v("photo_camera"),
              ]),
              _vm._v("\n                Static\n            "),
            ]
          ),
          _vm._v(" "),
          _c("a-switch", {
            staticClass: "mode-switch",
            on: { change: _vm.onModeChanged },
            model: {
              value: _vm.isDynamicMode,
              callback: function ($$v) {
                _vm.isDynamicMode = $$v
              },
              expression: "isDynamicMode",
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "mode-label",
              class: { active: _vm.currentMode === "dynamic" },
              on: {
                click: function ($event) {
                  return _vm.setMode("dynamic")
                },
              },
            },
            [
              _c("span", { staticClass: "material-icons" }, [_vm._v("code")]),
              _vm._v("\n                Dynamic\n            "),
            ]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.currentMode === "static"
      ? _c(
          "div",
          {
            staticClass: "image-bot-response",
            class: { empty: !_vm.defaultImageUrl },
          },
          [
            !_vm.defaultImageUrl && !_vm.selectedImage
              ? _c(
                  "div",
                  {
                    staticClass: "placeholder",
                    on: { click: _vm.openSelectImage },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v(" photo_camera "),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.dragAndDropBrowse"))),
                    ]),
                  ]
                )
              : _c(
                  "div",
                  {
                    staticClass: "position-relative",
                    on: {
                      mouseover: function ($event) {
                        _vm.hovered = true
                      },
                      mouseleave: function ($event) {
                        _vm.hovered = false
                      },
                    },
                  },
                  [
                    _vm.defaultImageUrl && !_vm.uploading
                      ? _c("img", {
                          staticClass: "preview",
                          attrs: { src: _vm.defaultImageUrl },
                        })
                      : _vm.selectedImageSrc
                      ? _c("img", {
                          staticClass: "preview",
                          attrs: { src: _vm.selectedImageSrc },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.uploading
                      ? _c(
                          "div",
                          { staticClass: "uploading-banner" },
                          [
                            _c("a-progress", {
                              attrs: {
                                type: "circle",
                                "stroke-color": {
                                  "0%": "#108ee9",
                                  "100%": "#87d068",
                                },
                                percent: _vm.uploadProgress,
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("chatbotv2.imageUploading")) +
                                  " ..."
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.defaultImageUrl && !_vm.uploading && _vm.hovered
                      ? _c(
                          "div",
                          {
                            staticClass: "update-banner",
                            on: { click: _vm.openSelectImage },
                          },
                          [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v(" photo_camera "),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("chatbotv2.clickToChooseNewImage")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("chatbotv2.or")) +
                                  "\n                    "
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "remove",
                                  on: { click: _vm.removeImage },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("chatbotv2.removeTheExistingOne")
                                    )
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.currentMode === "dynamic"
      ? _c(
          "div",
          { staticClass: "dynamic-image-url" },
          [
            _c("label", { staticClass: "url-label" }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.imageUrl")) + ":"),
            ]),
            _vm._v(" "),
            _c("TiptapEditor", {
              attrs: {
                placeholder: _vm.$t("chatbotv2.enterImageUrlHere"),
                "show-attributes": true,
                "show-emoji": false,
                "preview-mode": false,
                "whatsapp-mode": _vm.whatsappMode,
                "allowed-attributes": _vm.allowedAttributes,
              },
              model: {
                value: _vm.dynamicImageUrl,
                callback: function ($$v) {
                  _vm.dynamicImageUrl = $$v
                },
                expression: "dynamicImageUrl",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }